import { render, staticRenderFns } from "./by-tag-mobile.vue?vue&type=template&id=6a7486f9"
import script from "./by-tag-mobile.vue?vue&type=script&lang=js"
export * from "./by-tag-mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports